import React from 'react';

import {ReactComponent as ComingSoonSvg} from "../../assets/image/svg/comingSoonIcon.svg"

const ComingSoon: React.FC = () => {
  const containerStyle: React.CSSProperties = {
   
    width: '100%',
    height: '100%',
    backgroundColor: '#fff', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    zIndex: 9999,
  };

  const svgContainerStyle: React.CSSProperties = {
    maxWidth: '30vw', 
    maxHeight: '30vh', 
    height: 'auto',
    marginBottom: '2rem',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#333',     
    marginBottom: '0.5rem', 
    textShadow: '1px 1px 2px rgba(0,0,0,0.1)', 
  };

  const messageStyle: React.CSSProperties = {
    fontSize: '1.1rem',
    color: '#555',   
    maxWidth: '60%',   
    lineHeight: '1.6',
  };


  return (
    <div className="coming-soon-container" style={containerStyle}>
      <div className="coming-soon-svg-container" style={svgContainerStyle}>
       <ComingSoonSvg/>
      </div>
      <h2 style={titleStyle}>Coming Soon!</h2>
      <p style={messageStyle}>
        This exciting feature is currently being developed and will be available shortly.
        Thank you for your patience and stay tuned for updates!
      </p>
    </div>
  );
};

export default ComingSoon;